import { API } from '../../apis/limeAuthUtils/apiWrapper';

// Private groups are the same FTDF groups a bot account subscribes to, so the lookup is
// shared rather than copied. Re-exported so the IAM role pages mock one module in tests.
export { fetchSubscribedGroups } from '../bot-accounts/apis';

const API_NAME = 'v1/iam-management';

export async function listAllIAMRoles() {
    /**
     * function to list the IAM roles onboarded for Device Farm IAM auth that the user manages
     */
    return await API.get(API_NAME, '/v1/role', {});
}

export async function getIAMRole(identityId) {
    /**
     * function to read one onboarded IAM role, including its private groups per region
     * @param {string} identityId - the role's identity_id (its Device Farm role ARN)
     */
    const myInit = {
        queryStringParameters: {
            identityId: identityId,
        },
    };
    return await API.get(API_NAME, '/v1/role', myInit);
}

export async function onboardIAMRole(team, callerRoleArns, ownerGroup, description, subscribedGroups) {
    /**
     * function to onboard a team for Device Farm IAM auth. The response carries the handback:
     * everything the team needs to call Device Farm with its own AWS credentials.
     * @param {string} team - becomes the role name adf-iam-auth-<team>
     * @param {string[]} callerRoleArns - IAM role or user ARNs allowed to assume the role
     * @param {string} ownerGroup - LDAP group that owns the role
     * @param {string} description - optional description
     * @param {Object<string, string[]>} subscribedGroups - private group ids per region
     */
    const myInit = {
        body: {
            team: team,
            callerRoleArns: callerRoleArns,
            ownerGroup: ownerGroup,
            description: description,
            subscribedGroups: subscribedGroups,
        },
    };
    return await API.post(API_NAME, '/v1/role', myInit);
}

export async function configureIAMRole(identityId, callerRoleArns, ownerGroup, description, subscribedGroups) {
    /**
     * function to configure an onboarded IAM role. Every field is the full desired state.
     * @param {string} identityId - the role's identity_id
     * @param {string[]} callerRoleArns - the complete set of trusted callers
     * @param {string} ownerGroup - LDAP group that owns the role
     * @param {string} description - description
     * @param {Object<string, string[]>} subscribedGroups - the complete set of private group ids per region
     */
    const myInit = {
        body: {
            identityId: identityId,
            callerRoleArns: callerRoleArns,
            ownerGroup: ownerGroup,
            description: description,
            subscribedGroups: subscribedGroups,
        },
    };
    return await API.put(API_NAME, '/v1/role', myInit);
}

export async function offboardIAMRole(identityId) {
    /**
     * function to permanently offboard an IAM role from Device Farm
     * @param {string} identityId - the role's identity_id
     */
    const myInit = {
        body: {
            identityId: identityId,
        },
    };
    return await API.del(API_NAME, '/v1/role', myInit);
}

export async function setIAMRoleStatus(identityId, status) {
    /**
     * function to disable (INACTIVE) or enable (ACTIVE) an IAM role. Device Farm admins only.
     * @param {string} identityId - the role's identity_id
     * @param {string} status - ACTIVE or INACTIVE
     */
    const myInit = {
        body: {
            identityId: identityId,
            status: status,
        },
    };
    return await API.put(API_NAME, '/v1/role/status', myInit);
}
